<!-- Top Breadcrumbs Bar with Back Action -->
<div class="fd-detail-header-wrapper">
  <nav class="fd-custom-breadcrumb">
    <a class="fd-breadcrumb-link" (click)="goToDashboard()">Home</a>
    <span class="fd-breadcrumb-sep">/</span>
    <a class="fd-breadcrumb-link" (click)="goBack()">Tickets</a>
    <span class="fd-breadcrumb-sep">/</span>
    <span class="fd-breadcrumb-current">#{{ ticket?.id }}</span>
  </nav>
</div>

<!-- 3-Column Split Layout -->
<div class="freshdesk-detail-view" *ngIf="ticket">
  <div class="fd-detail-container">
    
    <!-- 1. LEFT COLUMN: Ticket Status Flow & Lifecycle Timeline -->
    <div class="fd-lifecycle-sidebar">
      <div class="fd-lifecycle-header">
        <h4 class="fd-lifecycle-title">Status</h4>
      </div>

      <div class="fd-timeline-steps">
        <!-- Step 1: Created -->
        <div class="fd-timeline-step completed">
          <div class="fd-timeline-marker">
            <i class="fa fa-check"></i>
          </div>
          <div class="fd-timeline-content">
            <div class="fd-timeline-title">Ticket Created</div>
            <div class="fd-timeline-subtitle">{{ ticket.createdDate | date:'medium' }}</div>
            <div class="fd-timeline-detail">By {{ getRequesterDisplayName(ticket) }}</div>
          </div>
        </div>

        <!-- Step 2: Current Status -->
        <div class="fd-timeline-step active">
          <div class="fd-timeline-marker">
            <i class="fa fa-circle"></i>
          </div>
          <div class="fd-timeline-content">
            <div class="fd-timeline-title">Current State</div>
            <span class="fd-status-pill badge-{{ ticket.status?.toLowerCase() }}">
              {{ ticket.status }}
            </span>
            <div class="fd-timeline-detail">Priority: <strong>{{ ticket.priority }}</strong></div>
          </div>
        </div>

        <!-- Step 3: Resolution / Closed -->
        <div class="fd-timeline-step" [ngClass]="ticket.status === 'Resolved' || ticket.status === 'Closed' ? 'completed' : (getSlaDetails(ticket).resolution.isOverdue ? 'overdue' : 'pending')">
          <div class="fd-timeline-marker">
            <i class="fa" [ngClass]="ticket.status === 'Resolved' || ticket.status === 'Closed' ? 'fa-check-circle' : 'fa-clock-o'"></i>
          </div>
          <div class="fd-timeline-content">
            <div class="fd-timeline-title">Target Resolution Time</div>
            <div class="fd-timeline-subtitle">{{ getSlaDetails(ticket).resolution.text }}</div>
            <div class="fd-timeline-detail">{{ getSlaDetails(ticket).resolution.date }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. CENTER COLUMN: Ticket Conversation & Content -->
    <div class="fd-conversation-center">
      
      <!-- Action Toolbar (With 3-dot View Switcher Menu) -->
      <div class="fd-action-toolbar">
        <div class="fd-toolbar-left">
          <span class="fd-toolbar-ticket-badge"><i class="fa fa-ticket"></i> #{{ ticket.id }}</span>
          <span class="fd-toolbar-active-view">
            <i class="fa" [ngClass]="activeTab === 'comments' ? 'fa-comments' : 'fa-history'"></i>
            {{ activeTab === 'comments' ? 'Comments' : 'Activities' }}
          </span>
        </div>
        <div class="fd-toolbar-right">
          <div class="fd-view-dropdown-wrapper">
            <button type="button" class="fd-three-dots-btn" (click)="toggleViewMenu($event)" title="Options">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div *ngIf="viewMenuOpen" class="fd-view-dropdown-menu" (click)="$event.stopPropagation()">
              <button type="button" class="fd-view-menu-item" [class.selected]="activeTab === 'comments'" (click)="switchViewTab('comments')">
                <div class="fd-menu-item-label">
                  <i class="fa fa-comments"></i>
                  <span>Comments</span>
                </div>
                <i *ngIf="activeTab === 'comments'" class="fa fa-check fd-menu-check"></i>
              </button>
              <button type="button" class="fd-view-menu-item" [class.selected]="activeTab === 'activities'" (click)="switchViewTab('activities')">
                <div class="fd-menu-item-label">
                  <i class="fa fa-history"></i>
                  <span>Activities</span>
                </div>
                <i *ngIf="activeTab === 'activities'" class="fa fa-check fd-menu-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Scrollable Conversation Area -->
      <div class="fd-conversation-scroll">
        
        <!-- Ticket Title & Tags -->
        <div class="fd-thread-header">
          <div class="fd-header-title-row">
            <i class="fa fa-globe fd-globe-header"></i>
            <h1 class="fd-main-title">{{ ticket.summary }}</h1>
          </div>
          <div class="fd-header-badges">
            <span *ngIf="isTicketOverdue(ticket)" class="fd-badge fd-badge-overdue">Overdue</span>
            <span *ngIf="ticket.orgId" class="fd-badge fd-badge-tag">org_id:{{ ticket.orgId }}</span>
            <span class="fd-badge fd-badge-tag">org_name:{{ ticket.orgName || 'Certiplate' }}</span>
          </div>
        </div>

        <!-- Dedicated Ticket Description Box -->
        <div class="fd-ticket-description-box">
          <div class="fd-description-box-content" (click)="handleContentClick($event)">
            <div *ngIf="ticket.description" [innerHTML]="getSanitizedDescriptionText(ticket.description)"></div>
            <div *ngIf="!ticket.description" class="fd-no-desc-placeholder">No description provided.</div>
          </div>

          <!-- Jira-style Attachments Section -->
          <div *ngIf="getAllTicketAttachments().length > 0" class="jira-attachments-section">
            <div class="jira-attachments-header" (click)="toggleAttachmentsCollapse()">
              <div class="jira-attachments-title">
                <i class="fa" [ngClass]="isAttachmentsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                <span>Attachments</span>
                <span class="jira-badge">{{ getAllTicketAttachments().length }}</span>
              </div>
              <div class="jira-attachments-header-actions" (click)="$event.stopPropagation()">
                <button
                  *ngIf="getAllTicketAttachments().length > 2"
                  type="button"
                  class="jira-show-all-btn"
                  (click)="toggleShowAllAttachments($event)"
                >
                  {{ showAllAttachments ? 'Show less' : 'Show all (' + getAllTicketAttachments().length + ')' }}
                </button>
              </div>
            </div>

            <!-- Attachments Cards Grid (matching Jira style: up to 2 cards, + Show all if >2) -->
            <div *ngIf="!isAttachmentsCollapsed" class="jira-attachments-grid">
              <div
                *ngFor="let att of getVisibleTicketAttachments()"
                class="jira-attachment-card"
                (click)="openAttachmentPreview(att, $event)"
                [title]="'Click to view ' + att.name"
              >
                <!-- Thumbnail Preview -->
                <div class="jira-card-preview">
                  <img
                    *ngIf="(att.isImage || isImageAttachment(att)) && !att.hasError"
                    [src]="att.signedUrl || att.url || att.attachment_url"
                    [alt]="att.name"
                    class="jira-card-thumb-img"
                    loading="lazy"
                    (error)="onAttachmentImgError(att)"
                  />
                  <div *ngIf="!(att.isImage || isImageAttachment(att)) || att.hasError" class="jira-card-file-fallback">
                    <i class="fa" [ngClass]="getFileIconClass(att.name)"></i>
                  </div>
                  <div class="jira-card-overlay">
                    <i class="fa fa-search-plus"></i>
                  </div>
                </div>

                <!-- Footer info -->
                <div class="jira-card-footer">
                  <div class="jira-card-filename" [title]="att.name">{{ att.name }}</div>
                  <div class="jira-card-meta">
                    {{ (att.createdDate || ticket.createdDate) | date:'d MMM y, h:mm a' }}
                  </div>
                </div>
              </div>

              <!-- "+N More" Card (shown when >2 attachments and not yet expanded) -->
              <div
                *ngIf="getAllTicketAttachments().length > 2 && !showAllAttachments"
                class="jira-attachment-card jira-show-more-card"
                (click)="toggleShowAllAttachments($event)"
                title="View all attachments"
              >
                <div class="jira-show-more-content">
                  <span class="jira-show-more-count">+{{ getAllTicketAttachments().length - 2 }}</span>
                  <span class="jira-show-more-label">Show all</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section Divider for Discussion/Comments or Activities -->
        <div class="fd-conversation-section-divider">
          <span class="fd-section-heading">
            <i class="fa" [ngClass]="activeTab === 'comments' ? 'fa-comments' : 'fa-history'"></i>
            {{ activeTab === 'comments' ? 'Comments (' + (ticketConversations?.length || 0) + ')' : 'Activity Log' }}
          </span>
          <div class="fd-heading-line"></div>
        </div>

        <!-- Ticket Activities Stream (Visible ONLY when activeTab === 'activities') -->
        <div *ngIf="activeTab === 'activities'" class="fd-activities-stream">
          <div *ngFor="let act of getTicketActivities()" class="fd-activity-card">
            <div class="fd-activity-avatar" [ngClass]="{'system-avatar': act.isSystem}" [ngStyle]="!act.isSystem ? {'background-color': getAvatarColor(act.actor)} : {}">
              <i *ngIf="act.isSystem" class="fa fa-cog"></i>
              <span *ngIf="!act.isSystem">{{ getAvatarInitial(act.actor) }}</span>
            </div>
            <div class="fd-activity-body">
              <div class="fd-activity-header">
                <div class="fd-activity-title-group">
                  <strong class="fd-activity-actor">{{ act.actor }}</strong>
                  <span class="fd-activity-time">{{ act.timeFormatted }}</span>
                </div>
                <span class="fd-activity-tag">{{ act.tag }}</span>
              </div>
              <ul class="fd-activity-details-list">
                <li *ngFor="let item of act.items">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Conversation Thread Replies (Visible ONLY when activeTab === 'comments') -->
        <div *ngIf="activeTab === 'comments' && ticketConversations && ticketConversations.length > 0" class="fd-replies-list">
          <div *ngFor="let conv of ticketConversations" 
               class="fd-reply-card" 
               [ngClass]="{'admin-reply': conv.is_admin}"
               (mouseenter)="conv.hovered = true"
               (mouseleave)="conv.showReactions || (conv.hovered = false)">
            <div class="fd-reply-avatar" [ngStyle]="{'background-color': getAvatarColor(conv.author_name)}">
              {{ getAvatarInitial(conv.author_name) }}
            </div>
            <div class="fd-reply-body">
              <div class="fd-reply-meta">
                <strong class="fd-author-name">{{ conv.author_name }}</strong>
                <span class="fd-reply-time">{{ conv.created_at | date:'medium' }}</span>
              </div>
              <div class="fd-reply-content" (click)="handleContentClick($event)" [innerHTML]="getSanitizedDescription(conv.body || conv.body_text)"></div>

              <!-- Reply Attachments -->
              <div *ngIf="conv.attachmentDetails && conv.attachmentDetails.length > 0" class="fd-reply-attachments">
                <button type="button" *ngFor="let att of conv.attachmentDetails" (click)="openAttachmentPreview(att, $event)" class="fd-attachment-chip preview-btn" [title]="att.name">
                  <i class="fa fa-paperclip"></i>
                  <span>{{ att.name }}</span>
                </button>
              </div>

              <!-- Reactions Row -->
              <div *ngIf="groupReactions(conv.reactions).length > 0" class="reactions-row">
                <span *ngFor="let reaction of groupReactions(conv.reactions)"
                  class="reaction-bubble"
                  [class.own-reaction]="reaction.users.includes(getCurrentUser())"
                  [matTooltip]="reaction.users.includes(getCurrentUser()) ? reaction.users.join(', ') + ' - Click to remove' : reaction.users.join(', ')"
                  matTooltipPosition="above"
                  (click)="addReaction(conv, reaction.emoji)">
                  {{ reaction.emoji }}<span class="reaction-count">{{ reaction.count }}</span>
                </span>
              </div>

              <!-- Thread Link Bar -->
              <div *ngIf="conv.replies?.length" class="thread-link-bar" (click)="openThread(conv)">
                <span class="thread-link-avatars">
                  <span *ngFor="let r of conv.replies.slice(0, 3)"
                    class="thread-avatar-mini"
                    [style.background-color]="getAvatarColor(r.author_name)">
                    {{ getAvatarInitial(r.author_name) }}
                  </span>
                </span>
                <span class="thread-link-count">
                  {{ conv.replies.length }} {{ conv.replies.length === 1 ? 'reply' : 'replies' }}
                </span>
                <span class="thread-link-view">View thread</span>
                <span class="thread-link-arrow">&gt;</span>
              </div>
            </div>

            <!-- Hover Action Toolbar -->
            <div class="action-toolbar" *ngIf="conv.hovered">
              <div class="reaction-dropdown" (click)="$event.stopPropagation()">
                <button type="button" class="toolbar-btn" (click)="openEmojiPicker(conv, $event)" matTooltip="Add reaction" matTooltipPosition="above">
                  <i class="bi bi-emoji-smile toolbar-icon"></i>
                </button>
                <div *ngIf="conv.showReactions" class="emoji-picker" (click)="$event.stopPropagation()">
                  <div *ngFor="let group of EMOJI_GROUPS" class="emoji-group">
                    <div class="emoji-group-items">
                      <span *ngFor="let emoji of group.emojis" (click)="addReaction(conv, emoji)">{{ emoji }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="toolbar-btn" (click)="openThread(conv)" matTooltip="Reply in thread" matTooltipPosition="above">
                <i class="bi bi-reply toolbar-icon"></i>
              </button>
              <button *ngIf="canDeleteComment(conv)" type="button" class="toolbar-btn" (click)="deleteComment(conv)" matTooltip="Delete" matTooltipPosition="above">
                <i class="bi bi-trash toolbar-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty comments placeholder if none yet -->
        <div *ngIf="activeTab === 'comments' && (!ticketConversations || ticketConversations.length === 0)" class="fd-empty-comments-state">
          <span>No comments yet. Start the conversation below.</span>
        </div>
      </div>

      <!-- Pinned Bottom Rich Text Composer Box (Visible ONLY when activeTab === 'comments') -->
      <section class="compose-shell" *ngIf="activeTab === 'comments'">
        <div class="compose-card">
          <div class="compose-quill-wrap" (click)="focusMainEditor()">
            <div class="composer-inline-actions" aria-label="Composer actions">
              <button type="button" class="composer-tool attachment-tool" (click)="openAttachmentPicker('main')" title="Attach file" aria-label="Attach file">
                <i class="fa fa-paperclip"></i>
              </button>

              <div class="mention-action-wrap">
                <button type="button" class="composer-tool mention-tool" title="@ Mention" (click)="openMentionMenu('main', true)" aria-label="@ Mention">
                  <i class="fa fa-at"></i>
                </button>

                <div
                  *ngIf="mentionMenuOpen && mentionMenuScope === 'main'"
                  class="mention-dropdown"
                  (mousedown)="beginMentionMenuInteraction()"
                  (click)="$event.stopPropagation()"
                >
                  <div class="mention-dropdown-header">
                    <span class="mention-dropdown-title">Mention people</span>
                  </div>
                  <div class="mention-search">
                    <i class="fa fa-search"></i>
                    <input
                      type="text"
                      placeholder="Search people..."
                      [(ngModel)]="mentionMenuQuery"
                    />
                  </div>
                  <div class="mention-options-list">
                    <button
                      *ngFor="let user of getFilteredMentionUsers()"
                      type="button"
                      class="mention-option"
                      (mousedown)="$event.preventDefault()"
                      (click)="selectMentionUser(user); $event.stopPropagation()"
                    >
                      <span class="mention-option-name">{{ mentionDisplayName(user) }}</span>
                      <span *ngIf="user.username" class="mention-option-hint">@{{ user.username }}</span>
                    </button>
                  </div>
                  <div *ngIf="getFilteredMentionUsers().length === 0" class="mention-empty">
                    No users match
                  </div>
                </div>
              </div>

              <button type="button" class="send-btn send-btn-inline" [disabled]="isSendingReply" (click)="sendTicketReply()" title="Send (Enter)">
                <mat-icon *ngIf="!isSendingReply">send</mat-icon>
                <i *ngIf="isSendingReply" class="fa fa-spinner fa-spin"></i>
                <span>Send</span>
              </button>
            </div>

            <!-- Quill Editor Target -->
            <div #ticketEditorRef class="compose-quill-target"></div>
          </div>

          <input
            #ticketAttachmentInput
            type="file"
            class="attachment-input"
            [attr.accept]="ALLOWED_ATTACHMENT_ACCEPT"
            multiple
            (change)="handleAttachmentSelection('main', $event)"
          />

          <!-- Attachment Chips Preview -->
          <div *ngIf="selectedAttachments.length > 0" class="attachment-chip-list">
            <span *ngFor="let file of selectedAttachments; let index = index" class="attachment-chip">
              <i class="fa fa-paperclip"></i>
              <span class="attachment-chip-name" [matTooltip]="file.name">{{ file.name }}</span>
              <button type="button" class="attachment-chip-remove" (click)="removeAttachment('main', index)" title="Remove attachment">
                <i class="fa fa-times"></i>
              </button>
            </span>
          </div>
        </div>
      </section>

    </div>

    <!-- 3. THREAD PANEL (Visible when activeThread is open) -->
    <aside class="thread-panel" *ngIf="activeThread">
      <div class="thread-panel-header">
        <div>
          <span class="thread-panel-kicker">CONVERSATION</span>
          <span class="thread-panel-title">Thread</span>
        </div>
        <button type="button" class="thread-close-btn" (click)="closeThread()" title="Close thread">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="thread-conversation-scroll">
        <!-- Original Parent Message -->
        <div class="thread-original-msg">
          <div class="fd-reply-card thread-parent-card"
               (mouseenter)="activeThread.hovered = true"
               (mouseleave)="activeThread.showReactions || (activeThread.hovered = false)">
            <div class="fd-reply-avatar" [ngStyle]="{'background-color': getAvatarColor(activeThread.author_name)}">
              {{ getAvatarInitial(activeThread.author_name) }}
            </div>
            <div class="fd-reply-body">
              <div class="fd-reply-meta">
                <strong class="fd-author-name">{{ activeThread.author_name }}</strong>
                <span class="fd-reply-time">{{ activeThread.created_at | date:'medium' }}</span>
              </div>
              <div class="fd-reply-content" (click)="handleContentClick($event)" [innerHTML]="getSanitizedDescription(activeThread.body || activeThread.body_text)"></div>

              <div *ngIf="activeThread.attachmentDetails && activeThread.attachmentDetails.length > 0" class="fd-reply-attachments">
                <button type="button" *ngFor="let att of activeThread.attachmentDetails" (click)="openAttachmentPreview(att, $event)" class="fd-attachment-chip preview-btn" [title]="att.name">
                  <i class="fa fa-paperclip"></i>
                  <span>{{ att.name }}</span>
                </button>
              </div>

              <div *ngIf="groupReactions(activeThread.reactions).length > 0" class="reactions-row">
                <span *ngFor="let reaction of groupReactions(activeThread.reactions)"
                  class="reaction-bubble"
                  [class.own-reaction]="reaction.users.includes(getCurrentUser())"
                  [matTooltip]="reaction.users.includes(getCurrentUser()) ? reaction.users.join(', ') + ' - Click to remove' : reaction.users.join(', ')"
                  matTooltipPosition="above"
                  (click)="addReaction(activeThread, reaction.emoji)">
                  {{ reaction.emoji }}<span class="reaction-count">{{ reaction.count }}</span>
                </span>
              </div>
            </div>

            <!-- Hover Action Toolbar on Parent -->
            <div class="action-toolbar" *ngIf="activeThread.hovered">
              <div class="reaction-dropdown" (click)="$event.stopPropagation()">
                <button type="button" class="toolbar-btn" (click)="openEmojiPicker(activeThread, $event)" matTooltip="Add reaction" matTooltipPosition="above">
                  <i class="bi bi-emoji-smile toolbar-icon"></i>
                </button>
                <div *ngIf="activeThread.showReactions" class="emoji-picker" (click)="$event.stopPropagation()">
                  <div *ngFor="let group of EMOJI_GROUPS" class="emoji-group">
                    <div class="emoji-group-items">
                      <span *ngFor="let emoji of group.emojis" (click)="addReaction(activeThread, emoji)">{{ emoji }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button *ngIf="canDeleteComment(activeThread)" type="button" class="toolbar-btn" (click)="deleteComment(activeThread)" matTooltip="Delete" matTooltipPosition="above">
                <i class="bi bi-trash toolbar-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Thread Divider -->
        <div class="thread-divider">
          <span class="thread-reply-count">
            {{ activeThread.replies?.length || 0 }} {{ (activeThread.replies?.length || 0) === 1 ? 'reply' : 'replies' }}
          </span>
          <div class="thread-divider-line"></div>
        </div>

        <!-- Thread Replies List -->
        <div class="thread-replies-list">
          <div *ngFor="let reply of activeThread.replies"
               class="fd-reply-card thread-reply-item"
               (mouseenter)="reply.hovered = true"
               (mouseleave)="reply.showReactions || (reply.hovered = false)">
            <div class="fd-reply-avatar" [ngStyle]="{'background-color': getAvatarColor(reply.author_name)}">
              {{ getAvatarInitial(reply.author_name) }}
            </div>
            <div class="fd-reply-body">
              <div class="fd-reply-meta">
                <strong class="fd-author-name">{{ reply.author_name }}</strong>
                <span class="fd-reply-time">{{ reply.created_at | date:'medium' }}</span>
              </div>
              <div class="fd-reply-content" (click)="handleContentClick($event)" [innerHTML]="getSanitizedDescription(reply.body || reply.body_text)"></div>

              <div *ngIf="reply.attachmentDetails && reply.attachmentDetails.length > 0" class="fd-reply-attachments">
                <button type="button" *ngFor="let att of reply.attachmentDetails" (click)="openAttachmentPreview(att, $event)" class="fd-attachment-chip preview-btn" [title]="att.name">
                  <i class="fa fa-paperclip"></i>
                  <span>{{ att.name }}</span>
                </button>
              </div>

              <div *ngIf="groupReactions(reply.reactions).length > 0" class="reactions-row">
                <span *ngFor="let reaction of groupReactions(reply.reactions)"
                  class="reaction-bubble"
                  [class.own-reaction]="reaction.users.includes(getCurrentUser())"
                  [matTooltip]="reaction.users.includes(getCurrentUser()) ? reaction.users.join(', ') + ' - Click to remove' : reaction.users.join(', ')"
                  matTooltipPosition="above"
                  (click)="addReaction(reply, reaction.emoji)">
                  {{ reaction.emoji }}<span class="reaction-count">{{ reaction.count }}</span>
                </span>
              </div>
            </div>

            <!-- Hover Action Toolbar on Reply -->
            <div class="action-toolbar" *ngIf="reply.hovered">
              <div class="reaction-dropdown" (click)="$event.stopPropagation()">
                <button type="button" class="toolbar-btn" (click)="openEmojiPicker(reply, $event)" matTooltip="Add reaction" matTooltipPosition="above">
                  <i class="bi bi-emoji-smile toolbar-icon"></i>
                </button>
                <div *ngIf="reply.showReactions" class="emoji-picker" (click)="$event.stopPropagation()">
                  <div *ngFor="let group of EMOJI_GROUPS" class="emoji-group">
                    <div class="emoji-group-items">
                      <span *ngFor="let emoji of group.emojis" (click)="addReaction(reply, emoji)">{{ emoji }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button *ngIf="canDeleteComment(reply)" type="button" class="toolbar-btn" (click)="deleteComment(reply)" matTooltip="Delete" matTooltipPosition="above">
                <i class="bi bi-trash toolbar-icon"></i>
              </button>
            </div>
          </div>

          <div *ngIf="!activeThread.replies?.length" class="thread-empty">
            Be the first to reply.
          </div>
        </div>
      </div>

      <!-- Thread Composer Shell -->
      <div class="thread-compose-shell">
        <div class="thread-compose-card">
          <div class="thread-compose-editor">
            <div #threadEditorRef class="compose-quill-target thread-compose-target"></div>
            <div class="thread-actions-row">
              <div class="thread-toolbar-actions" aria-label="Composer actions">
                <button type="button" class="composer-tool thread-attachment-tool" (click)="openAttachmentPicker('thread')" title="Attach file" aria-label="Attach file">
                  <i class="fa fa-paperclip"></i>
                </button>
                <div class="thread-mention-wrap">
                  <button type="button" class="composer-tool thread-mention-tool" title="@ Mention" (click)="openMentionMenu('thread', true)" aria-label="@ Mention">
                    <i class="fa fa-at"></i>
                  </button>
                  <div *ngIf="mentionMenuOpen && mentionMenuScope === 'thread'"
                    class="thread-mention-dropdown"
                    (mousedown)="beginMentionMenuInteraction()"
                    (click)="$event.stopPropagation()">
                    <div class="thread-mention-dropdown-header">
                      <span class="thread-mention-dropdown-title">Mention people</span>
                    </div>
                    <div class="mention-search">
                      <i class="fa fa-search"></i>
                      <input type="text" placeholder="Search people..." [(ngModel)]="mentionMenuQuery" />
                    </div>
                    <div class="mention-options-list">
                      <button *ngFor="let user of getFilteredMentionUsers()"
                        type="button"
                        class="thread-mention-option"
                        (mousedown)="$event.preventDefault()"
                        (click)="selectMentionUser(user); $event.stopPropagation()">
                        <span class="thread-mention-option-name">{{ mentionDisplayName(user) }}</span>
                        <span *ngIf="user.username" class="thread-mention-option-hint">@{{ user.username }}</span>
                      </button>
                    </div>
                    <div *ngIf="getFilteredMentionUsers().length === 0" class="thread-mention-empty">
                      No users match
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="send-btn thread-send-btn" [disabled]="isSendingThreadReply" (click)="submitThreadReply()" title="Reply (Enter)">
                <mat-icon *ngIf="!isSendingThreadReply">send</mat-icon>
                <i *ngIf="isSendingThreadReply" class="fa fa-spinner fa-spin"></i>
                <span>Send</span>
              </button>
            </div>
          </div>
          <input #threadAttachmentInput type="file" class="attachment-input" [attr.accept]="ALLOWED_ATTACHMENT_ACCEPT" multiple (change)="handleAttachmentSelection('thread', $event)" />
          <div *ngIf="threadAttachments.length > 0" class="attachment-chip-list">
            <span *ngFor="let file of threadAttachments; let index = index" class="attachment-chip">
              <i class="fa fa-paperclip"></i>
              <span class="attachment-chip-name" [matTooltip]="file.name">{{ file.name }}</span>
              <button type="button" class="attachment-chip-remove" (click)="removeAttachment('thread', index)" title="Remove attachment">
                <i class="fa fa-times"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </aside>

    <!-- 4. RIGHT COLUMN: Properties Sidebar (Visible only for Super Admin) -->
    <div *ngIf="isSuperAdmin" class="fd-properties-sidebar">
      
      <div class="fd-props-body">
        <h4 class="fd-props-title">Details</h4>

        <!-- Tags -->
        <div class="fd-prop-group">
          <label>Tags</label>
          <div class="fd-prop-tags-container">
            <span *ngIf="ticket.orgId" class="fd-prop-tag">org_id:{{ ticket.orgId }}</span>
            <span class="fd-prop-tag">org_name:{{ ticket.orgName || 'Certiplate' }}</span>
          </div>
        </div>

        <!-- Status -->
        <div class="fd-prop-group">
          <label>Status <span class="text-danger">*</span></label>
          <select class="fd-prop-select" [(ngModel)]="selectedTicketStatus">
            <option [value]="2">Open</option>
            <option [value]="3">Pending</option>
            <option [value]="4">Resolved</option>
            <option [value]="5">Closed</option>
          </select>
        </div>

        <!-- Priority -->
        <div class="fd-prop-group">
          <label>Priority <span class="text-danger">*</span></label>
          <select class="fd-prop-select" [(ngModel)]="selectedTicketPriority">
            <option [value]="1">Low</option>
            <option [value]="2">Medium</option>
            <option [value]="3">High</option>
            <option [value]="4">Urgent</option>
          </select>
        </div>

        <!-- Assign To -->
        <div class="fd-prop-group">
          <label>Assign To</label>
          <input 
            type="email" 
            class="fd-prop-input" 
            placeholder="Enter assignee email" 
            [(ngModel)]="assignedToEmail"
          />
        </div>

        <!-- Organization -->
        <div class="fd-prop-group">
          <label>Organization</label>
          <div class="fd-prop-static">{{ ticket.orgName || 'N/A' }}</div>
        </div>

        <!-- Requester -->
        <div class="fd-prop-group">
          <label>Requester Email</label>
          <div class="fd-prop-static">{{ ticket.requesterEmail || 'N/A' }}</div>
        </div>

        <!-- Update Button -->
        <div class="fd-prop-update-action">
          <button class="fd-btn fd-btn-primary fd-btn-block" [disabled]="isUpdatingProperties" (click)="updateTicketProperties()">
            {{ isUpdatingProperties ? 'Updating...' : 'Update' }}
          </button>
        </div>
      </div>

    </div>

  </div>

  <!-- 5. ATTACHMENT PREVIEW MODAL (LIGHTBOX) -->
  <div
    *ngIf="attachmentPreviewOpen"
    class="attachment-preview-overlay"
    (click)="closeAttachmentPreview()"
  >
    <div class="attachment-preview-modal" (click)="$event.stopPropagation()">
      <div class="attachment-preview-header">
        <div class="attachment-preview-title">
          <i class="fa fa-paperclip"></i>
          <span [matTooltip]="previewFileName">{{ previewFileName }}</span>
        </div>
        <div class="attachment-preview-controls">
          <button
            type="button"
            class="attachment-preview-icon-btn download"
            (click)="downloadAttachmentFromPreview()"
            matTooltip="Download file"
            matTooltipPosition="above"
          >
            <i class="fa fa-download"></i>
          </button>
          <button
            type="button"
            class="attachment-preview-icon-btn close"
            (click)="closeAttachmentPreview()"
            matTooltip="Close preview"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="attachment-preview-body">
        <div *ngIf="previewLoading" class="attachment-preview-loading">
          <div class="preview-spinner"></div>
          <p>Loading preview...</p>
        </div>
        <ng-container *ngIf="!previewLoading">
          <iframe
            *ngIf="previewMode === 'pdf'"
            class="attachment-preview-frame"
            [src]="previewResourceUrl"
            title="PDF preview"
          ></iframe>
          <img
            *ngIf="previewMode === 'image'"
            class="attachment-preview-image"
            [src]="previewUrl"
            [alt]="previewFileName"
            (error)="onPreviewImageError()"
          />
          <video
            *ngIf="previewMode === 'video'"
            controls
            class="attachment-preview-video"
          >
            <source [src]="previewUrl" />
          </video>
          <pre *ngIf="previewMode === 'text'" class="attachment-preview-text">{{ previewText }}</pre>
          <pre *ngIf="previewMode === 'json'" class="attachment-preview-json">{{ previewJsonText }}</pre>
          <pre *ngIf="previewMode === 'docx'" class="attachment-preview-text">{{ previewDocxText }}</pre>
          <div *ngIf="previewMode === 'csv'" class="attachment-preview-table-wrap">
            <table class="attachment-preview-table">
              <thead *ngIf="previewCsvHeaders.length">
                <tr>
                  <th *ngFor="let header of previewCsvHeaders">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of previewCsvRows">
                  <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="previewMode === 'excel'" class="attachment-preview-table-wrap">
            <table class="attachment-preview-table">
              <thead *ngIf="previewExcelHeaders.length">
                <tr>
                  <th *ngFor="let header of previewExcelHeaders">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of previewExcelRows">
                  <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="previewMode === 'unsupported'" class="attachment-preview-empty">
            <h3>Preview not available</h3>
            <p>{{ previewMessage || 'Preview is not available for this attachment.' }}</p>
            <button type="button" class="fd-btn fd-btn-primary" (click)="downloadAttachmentFromPreview()" style="margin-top: 12px;">
              <i class="fa fa-download"></i> Download File
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

</div>
